import React from "react";
import { array, string } from "prop-types";
import { connect } from "react-redux";
import { Link } from "@quintype/components";
import get from "lodash/get";

import { Facebook, Instagram, Pinterest, X } from "./../../atoms/icons/StoryPageIcons";
import LinkView from "./../../atoms/link-view";
import YoutubeIcon from "./FooterIcons/YoutubeIcon";
import BottomIconView from "../../molecules/BottomIconView";

import { STATIC_PAGE_LINKS } from "../../../../isomorphic/constants";
import { getCurrentYear } from "../../utils/utils";

import "./footer.m.css";

const FooterView = ({ footerMenuLinks, footerStaticLinks, pageType }) => {
  return (
    <div>
      {pageType !== "static-page" && <BottomIconView />}
      <div styleName="wrapper">
        <ul styleName="menus">
          {footerMenuLinks.map((item, index) => (
            <li key={index} styleName="menu-item">
              <LinkView item={item} />
            </li>
          ))}
        </ul>

        <div styleName="social-icons">
          <Link aria-label="facebook icon" href={STATIC_PAGE_LINKS.facebook} target="_blank" rel="noopener noreferrer">
            <Facebook color="#fff" width={24} height={24} />
          </Link>
          <Link aria-label="twitter icon" href={STATIC_PAGE_LINKS.twitter} target="_blank" rel="noopener noreferrer">
            <X color="#fff" width={24} height={24} />
          </Link>
          <Link
            aria-label="instagram icon"
            href={STATIC_PAGE_LINKS.instagram}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Instagram color="#fff" width={24} height={24} />
          </Link>
          <Link aria-label="youtube iocn" href={STATIC_PAGE_LINKS.youtube} target="_blank" rel="noopener noreferrer">
            <YoutubeIcon color="#fff" width={24} height={24} />
          </Link>
          <Link
            aria-label="pinterest icon"
            href={STATIC_PAGE_LINKS.pinterest}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Pinterest color="#fff" width={24} height={24} />
          </Link>
        </div>

        <ul styleName="menus">
          {footerStaticLinks.map((item, index) => (
            <li key={index} styleName="static-menu-item">
              <LinkView item={item} />
            </li>
          ))}
        </ul>

        <div styleName="by-text">
          © হালফ্যাশন <time>{getCurrentYear()}</time>
        </div>
      </div>
    </div>
  );
};

FooterView.propTypes = {
  footerMenuLinks: array,
  footerStaticLinks: array,
  pageType: string,
};

const mapStateToProps = (state) => ({
  footerMenuLinks: get(state, ["qt", "data", "navigationMenu", "footerMenuLinks"], []),
  footerStaticLinks: get(state, ["qt", "data", "navigationMenu", "footerStaticLinks"], []),
  pageType: get(state, ["qt", "pageType"], []),
});

export default connect(mapStateToProps)(FooterView);
